<template>
    <div v-if="type === 'page'" class="flex">
        <a v-if="isFanned"
           aria-label="Unfan"
           class="relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs "
           href="#"
           v-on:click.prevent="unFan">
            <i class="fas fa-heart -ml-0.5 mr-2 h-4 w-4"></i>
            <span>{{ numberOfFans }}</span>
        </a>
        <a v-else
           aria-label="Fan"
           class="relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs"
           href="#"
           v-on:click.prevent="fan">
            <i class="far fa-heart -ml-0.5 mr-2 h-4 w-4"></i>
            <span>{{ numberOfFans }}</span>
        </a>
    </div>

    <div v-else class="">
        <a v-if="isFanned"
           aria-label="Unfan"
           class="px-3 py-2 rounded-xl text-clay-800 "
           href="#"
           v-on:click.prevent="unFan">
            <i class="mr-2 fas fa-heart hover:text-electric-700 hover:animate-ping"></i>
            <span>{{ numberOfFans }}</span>
        </a>
        <a v-else
           aria-label="Fan"
           class="px-3 py-2 rounded-xl text-clay-800 "
           href="#"
           v-on:click.prevent="fan">
            <i class="mr-2 far fa-heart hover:text-electric-700 hover:animate-ping"></i>
            <span>{{ numberOfFans }}</span>
        </a>
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {defineProps, onMounted, Ref, ref} from "vue";
import {store} from "@/store";
import {client, trackEvent} from '@/shared';
import {Fan, Unfan} from "@/dtos";

const props = defineProps({
    id: String,
    numberOfFans: Number,
    type: String
})
const id: Ref<String> = ref(props.id);
let numberOfFans: Ref<Number> = ref(props.numberOfFans ?? 0);
let isFanned: Ref<Boolean> = ref(false);
let type = props.type ?? "card";

onMounted((): void => {
    if (store.saUserSession.fannedItems.includes(id.value.toLowerCase())) {
        isFanned.value = true;
    }
});

const fan = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    await client.post(new Fan({id: id.value}))
        .then(() => {
            isFanned.value = true;
            numberOfFans.value++;
            
            trackEvent( 'fan', {
                content_id: id.value,
                content_type: id.value.split('/', 1)
            });
        })
};
const unFan = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    await client.delete(new Unfan({id: id.value}))
        .then(() => {
            isFanned.value = false;
            numberOfFans.value--;
        })
};
</script>